/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.1.0 (NJsonSchema v10.4.3.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export enum AddressType {
  Billing = 'Billing',
  Shipping = 'Shipping',
  Other = 'Other',
}

export enum AccountType {
  AccountReceivable = 'AccountReceivable',
  AccountPayable = 'AccountPayable',
}

export enum ItemType {
  Other = 'Other',
  Freight = 'Freight',
  Valuation = 'Valuation',
  Tax = 'Tax',
  OtherFreight = 'Other Freight',
  Inventory = 'Inventory',
}

export enum CustomFieldEntityType {
  Order = 'Order',
  Customer = 'Customer',
  Carrier = 'Carrier',
  Vendor = 'Vendor',
  Contact = 'Contact',
  SalesPerson = 'SalesPerson',
  FactoringCompany = 'FactoringCompany',
  Driver = 'Driver',
  Employee = 'Employee',
  ForwardingAgent = 'ForwardingAgent',
  Lead = 'Lead',
  Purchase = 'Purchase',
  PurchaseCarrier = 'PurchaseCarrier',
  PurchaseVendor = 'PurchaseVendor',
  Commodity = 'Commodity',
  AccountingItem = 'AccountingItem',
  AirShipmentOrder = 'AirShipmentOrder',
  OceanShipmentOrder = 'OceanShipmentOrder',
  AirShipmentCarrier = 'AirShipmentCarrier',
  ModeOfTransportation = 'ModeOfTransportation',
  Country = 'Country',
  ContactPaymentMethod = 'ContactPaymentMethod',
  CustomerAddress = 'CustomerAddress',
  CarrierAddress = 'CarrierAddress',
  VendorAddress = 'VendorAddress',
  ContactAddress = 'ContactAddress',
  DriverAddress = 'DriverAddress',
  EmployeeAddress = 'EmployeeAddress',
  SalesPersonAddress = 'SalesPersonAddress',
  ForwardingAgentAddress = 'ForwardingAgentAddress',
  FactoringCompanyAddress = 'FactoringCompanyAddress',
  LeadAddress = 'LeadAddress',
  Rate = 'Rate',
  PurposeOfCommodity = 'PurposeOfCommodity',
  ParcelShipment = 'ParcelShipment',
  Payment = 'Payment',
  CargoMovement = 'CargoMovement',
  OrderStatus = 'OrderStatus',
  CommodityType = 'CommodityType',
  State = 'State',
  ParcelShipmentCarrier = 'ParcelShipmentCarrier',
  City = 'City',
  EventDefinition = 'EventDefinition',
  JobStatus = 'JobStatus',
  Job = 'Job',
}

export enum CustomFieldType {
  Text = 'Text',
  Number = 'Number',
  Date = 'Date',
  Boolean = 'Boolean',
  PurposeOfCommodity = 'PurposeOfCommodity',
  DangerousItems = 'DangerousItemsInCommodity',
  ModeOfTransportation = 'ModeOfTransportation',
  EquipmentType = 'EquipmentType',
  Port = 'Port',
  ServiceType = 'ServiceType',
  Time = 'Time',
  TextArea = 'TextArea',
  ContactPaymentMethod = 'ContactPaymentMethod',
  Contact = 'Contact',
  Vessel = 'Vessel',
  CustomCode = 'CustomCode',
  DestinationCountries = 'DestinationCountries',
  Options = 'Options',
  OrderStatus = 'OrderStatus',
}

export enum PurposeOfCommodityValues {
  Gift = 'Gift',
  BusinessMerchandise = 'Business Merchandise',
  PersonalMerchandise = 'Personal Merchandise',
}

export enum DangerousItemsValues {
  DangerousGoods = 'Potential Dangerous Goods: Perfume, Oil, Nail Polish, Aerosol Sprays, Paint (Can’t be shipped by Express Service)',
  LithiumBatteryContainingGoods = 'Lithium batteries such as power banks, and portable electronic devices (PEDs) which contain lithium batteries such as phones, tablets, laptop computers, shavers, cameras, drones, tools, medical devices, e-bikes and scooters are also dangerous goods. In particular chargers, power banks and e-cigarettes (Must be shipped separately)',
}

export interface AccountingItemDto {
  organizationId: number;
  accountingItemId: number;
  accountId: number;
  description: string;
  isInactive: boolean;
  itemCode: string;
  itemType: ItemType;
  price?: number | undefined;
  salesTaxId: number;
  tariff?: TariffOptions;
  accountName: string;
  salesTaxCode: string;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  customValues?: object | undefined;
  links?: LinkDto[] | undefined;
}

export interface AccountingItemDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: AccountingAccountDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateAccountingItemCommandValues {
  organizationId: number;
  accountId: number;
  description: string;
  isInactive: boolean;
  itemCode: string;
  itemType: string;
  price?: number | undefined;
  salesTaxId: number;
  tariff?: TariffOptions;
  customValues?: object | undefined;
}

export interface UpdateAccountingItemCommandValues {
  organizationId: number;
  accountId: number;
  description: string;
  isInactive: boolean;
  itemCode: string;
  itemType: string;
  price?: number | undefined;
  salesTaxId: number;
  tariff?: TariffOptions;
}

export interface AccountingAccountDto {
  accountId: number;
  accountName: string;
  accountNumber: string;
  accountType: AccountType | null;
  isInactive: boolean;
  organizationId: number;
  parentAccountId: number;
  parentAccountName: string;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface AccountingAccountDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: AccountingAccountDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateAccountingAccountCommandValues {
  accountName: string;
  accountNumber: string;
  accountType: string;
  isInactive: boolean;
  parentAccountId: number;
}

export interface UpdateAccountingAccountCommandValues {
  accountName: string;
  accountNumber: string;
  accountType: string;
  isInactive: boolean;
  parentAccountId: number;
}

export interface ContactAddressDto {
  contactAddressId?: number;
  addressLine?: string | undefined;
  addressLine2?: string | undefined;
  addressType?: AddressType;
  cityName?: string | undefined;
  contactId?: number;
  countryCode?: string | undefined;
  countryName?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number | undefined;
  postalCode?: string | undefined;
  stateCode?: string | undefined;
  stateName?: string | undefined;
  links?: LinkDto[] | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  customValues?: object | undefined;
}

export interface ContactAddressDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ContactAddressDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface ContactViewPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ContactView[] | undefined;
  links?: LinkDto[] | undefined;
}

export class ContactView implements ContactViewDto {}

export interface ContactViewDto {
  contactId?: number;
  accountNumber?: string | undefined;
  contactFirstName?: string | undefined;
  contactLastName?: string | undefined;
  contactType?: ContactType;
  created?: string;
  createdBy?: string | undefined;
  createdByUserName?: string | undefined;
  divisionId?: number;
  divisionName?: string;
  emailAddress?: string | undefined;
  faxNumber?: string | undefined;
  idNumber?: string | undefined;
  idNumberType?: IDNumberType;
  lastModified?: string;
  lastModifiedBy?: string | undefined;
  lastModifiedByUserName?: string | undefined;
  mobilePhoneNumber?: string | undefined;
  name?: string | undefined;
  organizationId?: number;
  linkToContactId?: number | undefined;
  phoneNumber?: string | undefined;
  website?: string | undefined;
  links?: LinkDto[] | undefined;
  customValues?: object | undefined;
  contactStatus?: ContactStatusDto | undefined;
  isDeleted?: boolean;
}

export interface ContactDto {
  contactId?: number;
  accountNumber?: string | undefined;
  contactFirstName?: string | undefined;
  contactLastName?: string | undefined;
  contactType?: ContactType;
  created?: Date;
  createdBy?: string | undefined;
  createdByUserName?: string | undefined;
  divisionId?: number;
  divisionName?: string;
  emailAddress?: string | undefined;
  faxNumber?: string | undefined;
  idNumber?: string | undefined;
  idNumberType?: IDNumberType;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  lastModifiedByUserName?: string | undefined;
  mobilePhoneNumber?: string | undefined;
  name?: string | undefined;
  organizationId?: number | undefined;
  linkToContactId?: number | undefined;
  linkToContactName?: string | undefined;
  contactLinkType?: ContactLinkType | undefined;
  phoneNumber?: string | undefined;
  website?: string | undefined;
  contactAddresses?: ContactAddressDto[];
  links?: LinkDto[] | undefined;
  paymentTermId?: number;
  paymentTermDescription?: string | undefined;
  userEmployee?: UserEmployeeDto | undefined;
  creditLimit?: number | undefined;
  paidAs?: PaidAs | undefined;
  isACorporation?: boolean | undefined;
  carrierEquipments?: CarrierEquipmentDto[] | undefined;
  customValues?: object | undefined;
  contactStatusId?: number | undefined;
  contactStatus?: ContactStatusDto | undefined;
  tags?: string[] | undefined;
  isDeleted?: boolean;
  discounts?: DiscountDto[] | undefined;
}

export interface ContactDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ContactDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface ContactViewDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ContactViewDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export enum ContactType {
  Customer = 'Customer',
  Carrier = 'Carrier',
  Vendor = 'Vendor',
  Contact = 'Contact',
  Driver = 'Driver',
  Employee = 'Employee',
  SalesPerson = 'SalesPerson',
  ForwardingAgent = 'ForwardingAgent',
  FactoringCompany = 'FactoringCompany',
  Lead = 'Lead',
}

export enum ContactLinkType {
  ParentContact = 'ParentContact',
  FactoringCompany = 'FactoringCompany',
  SalesPerson = 'SalesPerson',
}

export interface ContainerDescriptionDto {
  organizationId?: number;
  containerDescriptionCode?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  description?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface ContainerDescriptionDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ContainerDescriptionDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface ContainerTypeDto {
  organizationId?: number;
  containerTypeCode?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  description?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface ContainerTypeDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ContainerTypeDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CountryDto {
  countryCode?: string | undefined;
  name?: string | undefined;
  organizationId?: number;
  customValues?: CountryCustomValues;
  links?: LinkDto[] | undefined;
}

export interface CountryDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: CountryDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface EntityFieldDto extends Column {
  description?: string | undefined;
  entity?: string | undefined;
  isVisible?: boolean;
  sortName?: string | undefined;
}

export interface EntityFieldDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: EntityFieldDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateContactAddressCommandValues {
  addressLine?: string | undefined;
  addressLine2?: string | undefined;
  addressType?: AddressType;
  cityName?: string | undefined;
  contactId?: number;
  countryCode?: string | undefined;
  postalCode?: string | undefined;
  stateCode?: string | undefined;
  customValues?: object | undefined;
}

export interface CreateContactCommandValues {
  accountNumber?: string | undefined;
  contactFirstName?: string | undefined;
  contactLastName?: string | undefined;
  contactType?: ContactType;
  divisionId?: number;
  emailAddress?: string | undefined;
  faxNumber?: string | undefined;
  idNumber?: string | undefined;
  idNumberType?: IDNumberType;
  mobilePhoneNumber?: string | undefined;
  name?: string | undefined;
  linkToContactId?: number | undefined;
  phoneNumber?: string | undefined;
  website?: string | undefined;
  creditLimit?: number | undefined;
  paidAs?: PaidAs | undefined;
  isACorporation?: boolean | undefined;
  carrierEquipments?: CarrierEquipmentDto[] | undefined;
  customValues?: object | undefined;
}

export interface CreateContainerDescriptionCommandValues {
  containerDescriptionCode?: string | undefined;
  description?: string | undefined;
}

export interface CreateContainerTypeCommandValues {
  containerTypeCode?: string | undefined;
  description?: string | undefined;
}

export interface CreateCountryCommandValues {
  countryCode?: string | undefined;
  name?: string | undefined;
}

export interface CreateDivisionCommandValues {
  assignDivisionToEntities?: boolean;
  comments?: string | undefined;
  divisionName?: string | undefined;
  email?: string | undefined;
  faxNumber?: string | undefined;
  phoneNumber?: string | undefined;
  useDivisionInDocumentHeaders?: boolean;
  streetAndNumber?: string | undefined;
  city?: string | undefined;
  countryCode?: string | undefined;
  countryName?: string | undefined;
  zipCode?: string | undefined;
  stateCode?: string | undefined;
  stateName?: string | undefined;
  portId?: number | string | undefined;
  portName?: string | undefined;
  airAMSOriginatorCode?: string | undefined;
}

export interface CreateEquipmentTypeCommandValues {
  name?: string | undefined;
}

export interface CreateOrderCommandValues {
  billToContactId?: number | undefined;
  carrierContactId?: number | undefined;
  divisionId?: number;
  equipmentTypeId?: number | undefined;
  employeeContactId?: number | undefined;
  orderNumber?: string | undefined;
  orderStatusId?: number | undefined;
  salespersonContactId?: number | undefined;
  orderEntities?: CreateOrderEntityCommandValues[] | undefined;
  orderDocuments?: CreateOrderDocumentCommandValues[] | undefined;
  commodities?: CommodityDto[] | undefined;
  charges?: CreateChargeCommand[] | undefined;
  trackingEvents?: CreateTrackingEventCommand[] | undefined;
  carriersId: number[];
  customValues?: object | undefined;
  trackingNumber?: number;
  orderType?: OrderTypes;
}

export interface ReceiveCarrierPayCommandValues {
  orderCarrierId?: number | undefined;
  receivedDate?: Date | undefined;
  transactionNumber?: string | undefined;
}

export interface ReceiveDriverPayCommandValues {
  driverContactId?: number | undefined;
  receivedDate?: Date | undefined;
  orderIds?: number[] | undefined;
}

export interface GenerateInvoiceCommandValues {
  orderId: number;
  customerId: number;
  receivedDate?: Date | undefined;
  transactionNumber?: string | undefined;
}

export interface CreateOrganizationCommandValues {
  addressLine?: string | undefined;
  addressLine2?: string | undefined;
  cityName?: string | undefined;
  companyName?: string | undefined;
  countryCode?: string | undefined;
  faxNumber?: string | undefined;
  phoneNumber?: string | undefined;
  postalCode?: string | undefined;
  stateCode?: string | undefined;
}

export interface CreatePackageCategoryCommandValues {
  packageCategoryCode?: string | undefined;
  isContainer?: boolean;
  name?: string | undefined;
}

export interface CreatePackageTypeCommandValues {
  air?: boolean;
  containerDescriptionCode?: string | undefined;
  containerTypeCode?: string | undefined;
  ground?: boolean;
  height?: number;
  length?: number;
  maximumWeight?: number;
  name?: string | undefined;
  ocean?: boolean;
  packageCategoryCode?: string | undefined;
  volume?: number;
  weight?: number;
  width?: number;
}

export interface CreatePortCommandValues {
  portId?: string | number;
  air?: boolean;
  borderCrossingPoint?: boolean;
  countryCode?: string | undefined;
  isMyCompany?: boolean;
  mail?: boolean;
  mariTime?: boolean;
  name?: string | undefined;
  portRemarks?: string | undefined;
  rall?: boolean;
  road?: boolean;
  stateCode?: string | undefined;
}

export interface CreateStateCommandValues {
  countryCode?: string | undefined;
  stateCode?: string | undefined;
  name?: string | undefined;
}

export interface GetEmailCommandValues {
  documentTemplateType?: DocumentTemplateType | undefined;
  metadata?: object | undefined;
}

export interface CreateUserCommand {
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
}

export interface CreateUserRegistrationCommand {
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
}

export interface DivisionDto {
  divisionId?: number;
  assignDivisionToEntities?: boolean;
  useDivisionInDocumentHeaders?: boolean;
  streetAndNumber?: string | undefined;
  city?: string | undefined;
  countryCode?: string | undefined;
  countryName?: string | undefined;
  zipCode?: string | undefined;
  stateCode?: string | undefined;
  stateName?: string | undefined;
  portId?: number | string | undefined;
  portName?: string | undefined;
  airAMSOriginatorCode?: string | undefined;
  comments?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  divisionName?: string | undefined;
  email?: string | undefined;
  faxNumber?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number;
  phoneNumber?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface EmailDto {
  subject?: string | undefined;
  emailBody?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface DivisionDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: DivisionDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface DocumentTemplateDto {
  documentTemplateId?: number;
  bodyHtmlTemplate?: string | undefined;
  bodyTextTemplate?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  description?: string | undefined;
  documentTemplateType?: DocumentTemplateType;
  fileNameTemplate?: string | undefined;
  isDefault?: boolean;
  isInactive?: boolean;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  name?: string | undefined;
  organizationId?: number;
  subjectTemplate?: string | undefined;
  createdByUserName?: string | undefined;
  updatedByUserName?: string | undefined;
  paperSize?: PaperSizes;
  customPaperSize?: string | undefined;
  margins?: string | undefined;
  links?: LinkDto[] | undefined;
  templatingEngine?: TemplatingEngines;
  gqlQuery?: string | undefined;
  gqlVariables?: { [key: string]: any } | undefined;
}

export interface DocumentTemplateDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: DocumentTemplateDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateDocumentTemplateCommandValues {
  bodyHtmlTemplate?: string | undefined;
  bodyTextTemplate?: string | undefined;
  customPaperSize?: string | undefined;
  description?: string | undefined;
  documentTemplateType?: DocumentTemplateType;
  fileNameTemplate?: string | undefined;
  isDefault?: boolean;
  isInactive?: boolean;
  margins?: string | undefined;
  name?: string | undefined;
  paperSize?: PaperSizes;
  subjectTemplate?: string | undefined;
}

export interface UpdateDocumentTemplateCommandValues {
  bodyHtmlTemplate?: string | undefined;
  bodyTextTemplate?: string | undefined;
  customPaperSize?: string | undefined;
  description?: string | undefined;
  documentTemplateType?: DocumentTemplateType;
  fileNameTemplate?: string | undefined;
  isDefault?: boolean;
  isInactive?: boolean;
  margins?: string | undefined;
  name?: string | undefined;
  paperSize?: PaperSizes;
  subjectTemplate?: string | undefined;
}

export interface EquipmentTypeDto {
  equipmentTypeId?: number;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  name?: string | undefined;
  organizationId?: number;
  links?: LinkDto[] | undefined;
}

export interface EquipmentTypeDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: EquipmentTypeDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface GetContactAddressesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
}

export interface GetContactsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetContainerDescriptionsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetContainerTypesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetCountriesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetCitiesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetDivisionsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetEquipmentTypesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetOrdersQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetOrganizationsQuery {
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
}

export interface GetPackageCategoriesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetPackageTypesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetPortsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetVesselsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetStatesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
}

export interface GetSalesTaxesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetPaymentTermsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetPaymentsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetModeOfTransportationsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetCurrenciesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetOrganizationConfigsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetContactStatusesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetUsersQuery {
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export enum IDNumberType {
  EIN = 'EIN',
  DUNS = 'DUNS',
  ForeignEntityId = 'ForeignEntityId',
  Other = 'Other',
}

export enum DecimalPlace {
  Two = 2,
  Four = 4,
}

export enum AccountingTransactionStatus {
  Open = 'Open',
  Paid = 'Paid',
  Void = 'Void',
}

export enum AccountingTransactionStatusesColors {
  Open = '#3a3a3a',
  Paid = 'DodgerBlue',
  Void = 'gray',
}

export enum AccountingTransactionType {
  Invoice = 'Invoice',
  Bill = 'Bill',
}

export enum CargoMovementType {
  Local = 'Local',
  Transfer = 'Transfer',
  Picking = 'Picking',
  PutAway = 'PutAway',
  Service = 'Service',
  ToShipping = 'ToShipping',
}

export enum CargoMovementStatus {
  Created = 'Created',
  InProgress = 'InProgress',
  Finished = 'Finished',
}

export interface LinkDto {
  href?: string | undefined;
  rel?: string | undefined;
  type?: string | undefined;
  templated?: boolean | undefined;
}

export interface LinkResourceBaseDto {
  links?: LinkDto[] | undefined;
}

export class CommodityData implements CommodityDto {
  commodityStatus?: CommodityStatusDto | undefined;
  commodityStatusId?: number | undefined;
  description: string;
  dimensionsUnit: DimensionsUnit;
  height: number;
  length: number;
  organizationId: number;
  packageTypeId: number;
  pieces: number;
  volumePiece: number;
  volumeTotal: number;
  valueTotal: number;
  volumeUnit: VolumeUnit;
  weightTotal: number;
  weight: number;
  weightByTotal: boolean;
  weightUnit: WeightUnit;
  width: number;
  commodityId: number;
  links: LinkDto[] | undefined;
  packageTypeName: string;
  totalPcsCrt: number;
  note: string | null;
  quantity: number;
  unit: number | null;
  unitaryValue: number | null;
  commodityTypeId: number;
  commodityTypeCode: string;
  valueByTotal: boolean;
}

export interface AccountingTransactionDto {
  accountingTransactionId: number;
  divisionId: number;
  divisionName: string;
  accountId: number;
  accountingTransactionStatus: AccountingTransactionStatus;
  accountingTransactionType: AccountingTransactionType;
  applyToContactID: number;
  billToContactAddressId: number;
  dueDate: Date | string;
  paidDate?: Date | string | undefined;
  note: string;
  organizationId: number;
  paymentTermsId: number;
  transactionDate: Date | string;
  transactionNumber: string;
  amountDue: number;
  amountPaid: number;
  accountName: string;
  accountType?: AccountType | undefined;
  applyToContactName: string;
  applyToContactType: ContactType;
  paymentTermsDescription: string;
  billToContactAddressName: string;
  created: Date | string;
  createdBy: string;
  lastModified: Date | string;
  lastModifiedBy: string;
  createdByUserName: string;
  lastModifiedByUserName: string;
  paidAs: PaidAs;
  charges?: ChargeDto[] | undefined;
  totalAmount: number;
  links?: LinkDto[] | undefined;
}

export interface AccountingTransactionDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: AccountingTransactionDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateAccountingTransactionCommandValues {
  accountId: number;
  divisionId: number;
  accountingTransactionStatus: string;
  accountingTransactionType: string;
  applyToContactID: number;
  billToContactAddressId: number;
  dueDate: Date | string;
  paidAs: PaidAs;
  note: string;
  paymentTermsId: number;
  transactionDate: Date | string;
  transactionNumber: string;
  charges?: CreateChargeCommand[];
}

export interface UpdateAccountingTransactionCommandValues {
  accountId: number;
  divisionId: number;
  accountingTransactionStatus: AccountingTransactionStatus;
  accountingTransactionType: string;
  applyToContactID: number;
  billToContactAddressId: number;
  dueDate: Date | string;
  paidDate?: Date | string;
  paidAs: PaidAs;
  note: string;
  paymentTermsId: number;
  transactionDate: Date | string;
  transactionNumber: string;
  charges?: ChargeDto[] | undefined;
}

export interface UpdateChargeCommand {
  chargeId: number;
  values: UpdateChargeCommandValues;
}

export interface CreateChargeCommand {
  values: CreateChargeCommandValues;
}

export interface CurrencyDto {
  currencyId: number;
  created: Date;
  createdBy: string;
  currencyCode: string;
  currencyName: string;
  decimalPlaces: DecimalPlace;
  exchangeRateLastUpdate: Date;
  exchangeRateToPrimary: number;
  gainLossAccountId: number;
  gainLossAccountDescription: string;
  isInactive: boolean;
  lastModified: Date;
  lastModifiedBy: string;
  organizationId: number;
  symbol: string;
  createdByUserName: string;
  lastModifiedByUserName: string;
  links?: LinkDto[] | undefined;
}

export interface CurrencyDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: CurrencyDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateCurrencyCommandValues {
  currencyCode: string;
  currencyName: string;
  decimalPlaces: DecimalPlace;
  exchangeRateLastUpdate: Date;
  exchangeRateToPrimary: number;
  gainLossAccountId: number;
  isInactive: boolean;
  symbol: string;
}

export interface UpdateCurrencyCommandValues {
  currencyCode: string;
  currencyName: string;
  decimalPlaces: DecimalPlace;
  exchangeRateLastUpdate: Date;
  exchangeRateToPrimary: number;
  gainLossAccountId: number;
  isInactive: boolean;
  symbol: string;
}

export interface PaymentTermDto {
  paymentTermId: number;
  description: string;
  discountPaidWithinDays: number;
  discountPercentage: number;
  isInactive: boolean;
  netDueDays: number;
  organizationId: number;
  links?: LinkDto[] | undefined;
}

export interface CreatePaymentTermCommandValues {
  description: string;
  discountPaidWithinDays: number;
  discountPercentage: number;
  isInactive: boolean;
  netDueDays: number;
}

export interface UpdatePaymentTermCommandValues {
  description: string;
  discountPaidWithinDays: number;
  discountPercentage: number;
  isInactive: boolean;
  netDueDays: number;
}

export interface PaymentTermDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: PaymentTermDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CommodityShipment {
  orderId: number;
  orderType: OrderTypes;
  trackingNumber: string | undefined;
}

export interface CommodityDto {
  commodityId: number;
  commodityStatusId?: number | undefined;
  commodityStatus?: CommodityStatusDto | undefined;
  description: string;
  dimensionsUnit: DimensionsUnit;
  height: number;
  length: number;
  organizationId: number;
  packageTypeId: number;
  packageTypeName: string | null;
  note: string | null;
  unit: number | null;
  unitaryValue: number | null;
  quantity: number;
  pieces: number;
  valueTotal: number;
  volumePiece: number;
  volumeTotal: number;
  volumeUnit: VolumeUnit | string;
  weightTotal: number;
  weight: number;
  weightByTotal: boolean;
  weightUnit: WeightUnit;
  width: number;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
  commodityTypeId?: number;
  commodityTypeCode?: string;
  commodityTypeName?: string;
  commodityType?: CommodityTypeDto;
  customValues?: CommodityCustomValues;
  containerCommodityId?: number;
  warehouseLocationId?: number | null;
  warehouseLocation?: WarehouseLocationDto;
  containerCommodities?: CommodityDto[];
  containerCommodity?: ContainerCommodityDto;
  shipments?: CommodityShipment[];
  commodityTrackingNumber?: string | undefined;
  commodityTrackingNumbers?: CommodityTrackingNumberDto[] | undefined;
  jobId?: string;
  isRemoved?: boolean;
  valueByTotal: boolean;
}

export interface ContainerCommodityDto {
  commodityId: number;
  commodityStatusId?: number | undefined;
  commodityStatus?: CommodityStatusDto | undefined;
  description: string;
}

export interface CommodityDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: CommodityDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateCommodityCommandValues {
  commodityStatusId?: number | undefined;
  description: string;
  dimensionsUnit: string;
  height: number;
  length: number;
  organizationId: number;
  packageTypeId: number;
  pieces: number;
  volumePiece: number;
  volumeTotal: number;
  volumeUnit: string;
  weightTotal: number;
  weight: number;
  weightByTotal: boolean;
  weightUnit: string;
  width: number;
  note: string | null;
  unit: number | null;
  unitaryValue: number | null;
  quantity: number | null;
  warehouseLocationId?: number | null;
  customValues?: object | undefined;
}

export interface UpdateCommodityCommandValues {
  commodityStatusId?: number | undefined;
  description: string;
  dimensionsUnit: string;
  height: number;
  length: number;
  organizationId: number;
  packageTypeId: number;
  pieces: number;
  volumePiece: number;
  volumeTotal: number;
  volumeUnit: string;
  weightTotal: number;
  weight: number;
  weightByTotal: boolean;
  weightUnit: string;
  width: number;
  note: string | null;
  unit: number | null;
  unitaryValue: number | null;
  quantity: number | null;
  warehouseLocationId?: number | null;
  customValues?: object | undefined;
  containerCommodityId?: number;
}

export interface UpdateOneOfManyCommodityValues
  extends UpdateCommodityCommandValues {
  commodityId: number;
}

export interface OrderDto {
  orderId?: number;
  billToContactId?: number | undefined;
  billToContactName?: string | undefined;
  billToContactType?: ContactType | undefined;
  billToContactAccountNumber?: string | undefined;
  billToContactStatus?: string | undefined;
  carrierContactId?: number | undefined;
  carrierContactName?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  divisionId?: number;
  divisionName?: string;
  equipmentTypeId?: number | undefined;
  equipmentTypeName?: string | undefined;
  employeeContactId?: number | undefined;
  employeeContactName?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  orderNumber?: string | undefined;
  orderStatusId?: number;
  orderStatus?: OrderStatusDto;
  quoteStatus?: string | QuoteStatuses;
  organizationId?: number;
  salespersonContactId?: number | undefined;
  salespersonContactName?: string | undefined;
  commodities?: CommodityDto[] | undefined;
  charges?: ChargeDto[] | undefined;
  trackingEvents?: TrackingEventDto[] | undefined;
  totalPcsCrt: number;
  weighTotal: number;
  volumeTotal: number;
  carriers: ContactDto[];
  links?: LinkDto[] | undefined;
  createdByUserName: string;
  lastModifiedByUserName: string;
  customValues?: { [key: string]: any } | undefined;
  trackingNumber?: number;
  modeOfTransportationId?: number;
  modeOfTransportationDescription?: string;
  transportationMethod?: TransportationMethod;
  paymentTermId?: number;
  paymentTermDescription?: string;
  expDate?: Date;
  orderType?: OrderTypes;
  orderEntities?: OrderEntityDto[] | undefined;
  orderDocuments?: OrderDocumentDto[] | undefined;
  problemReason?: string;
}

export interface UninvoicedOrderDto {
  organizationId: number | undefined;
  orderId: number | undefined;
  orderNumber: string | undefined;
  shippingDate?: Date | undefined;
  customerIds: number[] | undefined;
  customerNames: string[] | undefined;
  customerNamesString: string | undefined;
  carrierDriverIds: number[] | undefined;
  carrierDriverNames: string[] | undefined;
  carrierDriverNamesString: string | undefined;
  accountingTransactions: AccountingTransactionDto[] | undefined;
  trackingNumber: number | undefined;
  links: LinkDto[];
}

export interface OrderDtoPagedResult {
  summary?: SummaryItems | undefined;
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: OrderDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface UninvoicedOrderDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: UninvoicedOrderDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export enum OrderTypes {
  Order = 'Order',
  Quote = 'Quote',
  WarehouseReceipt = 'WarehouseReceipt',
  Purchase = 'Purchase',
  Commodity = 'Commodity',
  AirShipmentOrder = 'AirShipmentOrder',
  ParcelShipment = 'ParcelShipment',
  OceanShipmentOrder = 'OceanShipmentOrder',
  CargoMovement = 'CargoMovement',
}

export enum ConsolidatedShipmentTypes {
  AirShipmentOrder = 'AirShipmentOrder',
  OceanShipmentOrder = 'OceanShipmentOrder',
}

export enum OrderStatuses {
  Pending = 'Pending',
  Open = 'Open',
  Refused = 'Refused',
  Covered = 'Covered',
  Dispatched = 'Dispatched',
  OnRoute = 'On Route',
  UnLoading = 'Unloading',
  Loading = 'Loading',
  InYard = 'In Yard',
  Invoiced = 'Invoiced',
  Delivered = 'Delivered',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}

export enum ManualOrderStatuses {
  Pending = 'Pending',
  Open = 'Open',
  Refused = 'Refused',
  Covered = 'Covered',
  Dispatched = 'Dispatched',
  OnRoute = 'On Route',
  UnLoading = 'Unloading',
  Loading = 'Loading',
  InYard = 'In Yard',
  Delivered = 'Delivered',
  Cancelled = 'Cancelled',
}

export enum CommodityStatuses {
  Pending = 'Pending',
  OnRoute = 'OnRoute',
  Delivered = 'Delivered',
  Cancelled = 'Cancelled',
  InQuote = 'In Quote',
  OnHand = 'OnHand',
  OnPacking = 'OnPacking',
}

export enum CommodityStatusesColors {
  Pending = 'gray',
  'On Route' = 'green',
  Delivered = 'DodgerBlue',
  Cancelled = 'gray',
}

export enum DimensionsUnit {
  In = 'In',
  Cm = 'Cm',
}

export enum WeightUnit {
  Lb = 'Lb',
  Kg = 'Kg',
}

export enum VolumeUnit {
  Ft = 'Ft³',
  Vlb = 'Vlb',
  Vkg = 'Vkg',
  M = 'm³',
}

export interface SummaryItems {
  totalCount: number;
  totalWeight: number;
  totalWeightUnits: WeightUnit;
  totalCube: number;
  totalCubeUnits: VolumeUnit;
}

export enum ChargeType {
  IncomeCharge = 'Income',
  //IncomeFreightCharge = 'Income Freight',
  ExpenseCharge = 'Expense',
  //ExpenseFreightCharge = 'Expense Freight',
}

export enum ApplyBy {
  Pieces = 'Pieces',
  Weight = 'Weight',
  ChargeableWeight = 'Chargeable Weight',
  Volume = 'Volume',
  Container = 'Container',
  Calculated = 'Calculated',
}

export enum PaidAs {
  Prepaid = 'Prepaid',
  Collect = 'Collect',
}

export enum PaperSizes {
  Letter = 'Letter',
  Legal = 'Legal',
  Ledger = 'Ledger',
  Tabloid = 'Tabloid',
  JuniorLegal = 'JuniorLegal',
  A0 = 'A0',
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  A4 = 'A4',
  A5 = 'A5',
  A6 = 'A6',
  A7 = 'A7',
  A8 = 'A8',
  A9 = 'A9',
  A10 = 'A10',
  B0 = 'B0',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  B4 = 'B4',
  B5 = 'B5',
  B6 = 'B6',
  B7 = 'B7',
  B8 = 'B8',
  B9 = 'B9',
  B10 = 'B10',
  C0 = 'C0',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  C5 = 'C5',
  C6 = 'C6',
  C7 = 'C7',
  C8 = 'C8',
  C9 = 'C9',
  C10 = 'C10',
  JIS_B0 = 'JIS_B0',
  JIS_B1 = 'JIS_B1',
  JIS_B2 = 'JIS_B2',
  JIS_B3 = 'JIS_B3',
  JIS_B4 = 'JIS_B4',
  JIS_B5 = 'JIS_B5',
  Custom = 'Custom',
}

export enum ChargeStatuses {
  Open = 'Open',
  Posted = 'Posted',
  Paid = 'Paid',
  Void = 'Void',
  Pending = 'Pending',
}

export enum ChargeStatusesColors {
  OpenIncome = 'green',
  PostedIncome = 'green',
  OpenExpense = 'red',
  PostedExpense = 'red',
  Paid = 'DodgerBlue',
  Void = 'gray',
}

export enum TransportationMethod {
  Ocean = 'Ocean',
  Rail = 'Rail',
  Ground = 'Ground',
  Air = 'Air',
  Mail = 'Mail',
  Unknown = 'Unknown',
  Pipe = 'Pipe',
}

export enum TransportationMethodDescription {
  Vessel = 'Vessel',
  VesselAndContainerized = 'VesselAndContainerized',
  Barge = 'Barge',

  Rail = 'Rail',
  RailAndContainerized = 'RailAndContainerized',

  Truck = 'Truck',
  TruckAndContainerized = 'TruckAndContainerized',
  Auto = 'Auto',
  Pedestrian = 'Pedestrian',
  RoadAndOther = 'RoadAndOther',

  Air = 'Air',
  AirAndContainerized = 'AirAndContainerized',

  Mail = 'Mail',

  PassengerAndHandCarried = 'PassengerAndHandCarried',

  FixedTransport = 'FixedTransport',
}

export enum DocumentTemplateType {
  RateConfirmationDocument = 'Rate Confirmation Document',
  RateConfirmationEmail = 'Rate Confirmation Email',
  InvoiceDocument = 'Invoice Document',
  InvoiceEmail = 'Invoice Email',
  BillOfLadingDocument = 'Bill of Lading Document',
  BillOfLadingEmail = 'Bill of Lading Email',
  ExportBillOfLadingDocument = 'Export Bill of Lading Document',
  QuoteConfirmationDocument = 'Quote Confirmation Document',
  QuoteConfirmationEmail = 'Quote Confirmation Email',
  ResetPasswordEmail = 'Reset Password Email',
  VerifyEmailAddressEmail = 'Verify Email Address Email',
  CustomsDeclarationDocument = 'Customs Declaration Document',
  ExportManifestDocument = 'Export Manifest Document',
  MasterBillOfLadingDocument = 'Master Bill Of Lading Document',
  DockReceiptDocument = 'Dock Receipt Document',
  AirWaybillDocument = 'Air Waybill Document',
  ShippingLabelDocument = 'Shipping Label Document',
  ExportManifestExcelDocument = 'ExportManifestExcelDocument',
  EventEmail = 'EventEmail',
  EmailNotification = 'EmailNotification',
}

export enum TemplatingEngines {
  Razor = 'Razor',
  Handlebars = 'Handlebars',
}

export enum VisibleTransactions {
  AllTransactions = 'All Transactions',
  DivisionOnly = 'With their division only',
  DivisionAndDivisionless = 'With their division and with no division assigned',
}

export enum AttachmentType {
  Picture = 'Picture',
  OtherDocument = 'OtherDocument',
  Avatar = 'Avatar',
}

export enum AttachmentParentType {
  Order = 'Order',
  AccountingTransaction = 'Accounting Transaction',
  Contact = 'Contact',
  EquipmentType = 'EquipmentType',
}

export enum PaymentStatus {
  Posted = 'Posted',
  Void = 'Void',
}

export enum ServiceType {
  PortToDoor = 'PortToDoor',
  DoorToDoor = 'DoorToDoor',
  DoorToPort = 'DoorToPort',
  PortToPort = 'PortToPort',
}

export interface OrganizationDto {
  organizationId?: number;
  addressLine?: string | undefined;
  addressLine2?: string | undefined;
  cityName?: string | undefined;
  companyName?: string | undefined;
  countryCode?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  faxNumber?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  phoneNumber?: string | undefined;
  postalCode?: string | undefined;
  stateCode?: string | undefined;
  links?: LinkDto[] | undefined;
  uniqueId?: string | undefined;
}

export interface OrganizationDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: OrganizationDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface PackageCategoryDto {
  packageCategoryCode?: string | undefined;
  organizationId?: number;
  created?: Date;
  createdBy?: string | undefined;
  isContainer?: boolean;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  name?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface PackageCategoryDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: PackageCategoryDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface SalesTaxDto {
  salesTaxId: number;
  authorityContactId: number;
  created: Date;
  createdBy: string;
  description: string;
  isGroupTax: boolean;
  isInactive: boolean;
  lastModified: Date;
  lastModifiedBy: string;
  organizationId: number;
  parentSalesTaxId: number;
  rate: number;
  taxCode: string;
  parentSalesTaxName: string;
  authorityContactName: string;
  createdByUserName: string;
  updatedByUserName: string;
  links?: LinkDto[] | undefined;
}

export interface SalesTaxDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: SalesTaxDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateSalesTaxCommandValues {
  authorityContactId: number;
  description: string;
  isGroupTax: boolean;
  isInactive: boolean;
  parentSalesTaxId: number;
  rate: number;
  taxCode: string;
}

export interface PatchCommandItemBase {
  value?: any;
  path?: string;
  op?: string;
  from?: string;
}

export interface PatchCommandBase {
  patchItems: PatchCommandItemBase[];
}

export interface UpdateSalesTaxCommandValues {
  authorityContactId: number;
  description: string;
  isGroupTax: boolean;
  isInactive: boolean;
  parentSalesTaxId: number;
  rate: number;
  taxCode: string;
}

export interface PackageTypeDto {
  packageTypeId?: number;
  air?: boolean;
  containerDescriptionCode?: string | undefined;
  containerTypeCode?: string | undefined;
  containerDescriptionCodeDescription?: string | undefined;
  containerTypeDescription?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  ground?: boolean;
  height?: number;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  length?: number;
  maximumWeight?: number;
  name?: string | undefined;
  ocean?: boolean;
  organizationId?: number;
  packageCategoryCode?: string | undefined;
  packageCategoryName?: string | undefined;
  volume?: number;
  weight?: number;
  width?: number;
  links?: LinkDto[] | undefined;
}

export interface PackageTypeDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: PackageTypeDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface ModeOfTransportationDto {
  modeOfTransportationId: number;
  created?: Date;
  createdBy?: string | undefined;
  description: string;
  organizationId: number;
  transportationMethod: TransportationMethod;
  transportationMethodDescription: TransportationMethodDescription;
  usCustomsCode: string;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
  customValues?: object | undefined;
}

export interface CreateModeOfTransportationCommandValues {
  description: string;
  transportationMethod: TransportationMethodCreate;
  usCustomsCode: string;
  customValues?: object | undefined;
}

export interface TransportationMethodCreate {
  transportationMethod: TransportationMethod;
  transportationMethodDescription: TransportationMethodDescription;
}

export interface UpdateModeOfTransportationCommandValues {
  description: string;
  transportationMethod: TransportationMethodUpdate;
  usCustomsCode: string;
  customValues?: object | undefined;
}

export interface TransportationMethodUpdate {
  transportationMethod: string;
  transportationMethodDescription: string;
}

export interface ModeOfTransportationDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ModeOfTransportationDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface GetChargesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
}

export interface ChargeDto {
  currencyName: string;
  chargeId: number;
  accountingItemId: number;
  amount: number;
  prepaid: number;
  expense: number;
  income: number;
  amountAndTaxAmount: number;
  currency: string;
  applyBy: ApplyBy;
  applyToContactId: number;
  chargeType: ChargeType;
  description: string;
  freightServiceClassId: number;
  grossVolume: number;
  grossWeight: number;
  isConsolidated: boolean;
  paidAs: PaidAs;
  pieces: number;
  price: number;
  quantity: number;
  showInDocuments: boolean;
  unit: string;
  salesTaxCode: string;
  applyToContactName: string;
  applyToContactType: ContactType | undefined;
  accountingItemName: string;
  chargeStatus: ChargeStatuses;
  salesTaxId: number;
  salesTaxRate: number;
  salesTaxAmount: number;
  totalAmount: number;
  allowAutomaticUpdate: boolean;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  note: string | undefined;
  rateId?: number | undefined;
  rate?: RateDto | undefined;
  currencyId: number;
  currencySymbol: string;
  currencyDecimals: DecimalPlace;
  createMode?: boolean;
  accountingItem?: AccountingItemDto | undefined;
  links?: LinkDto[] | undefined;
  organizationId?: number;
  isDeleted?: boolean;
}

export interface ChargeDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ChargeDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateChargeCommandValues {
  accountingItemId: number;
  currencyId: number;
  amount: number;
  applyBy: string;
  applyToContactId: number;
  chargeType: string;
  chargeStatus?: ChargeStatuses;
  description: string;
  freightServiceClassId: number;
  grossVolume: number;
  grossWeight: number;
  isConsolidated: boolean;
  paidAs: string;
  pieces: number;
  price: number;
  quantity: number;
  showInDocuments: boolean;
  unit: string;
  salesTaxId: number;
  salesTaxRate: number;
  salesTaxAmount: number;
  totalAmount: number;
  note: string;
  rateId?: number;
  allowAutomaticUpdate: boolean;
}

export interface UpdateChargeCommandValues {
  accountingItemId: number;
  currencyId: number;
  amount: number;
  applyBy: string;
  applyToContactId: number;
  chargeType: string;
  chargeStatus?: ChargeStatuses;
  description: string;
  freightServiceClassId: number;
  grossVolume: number;
  grossWeight: number;
  isConsolidated: boolean;
  isDeleted?: boolean;
  paidAs: string;
  pieces: number;
  price: number;
  quantity: number;
  showInDocuments: boolean;
  unit: string;
  salesTaxId: number;
  salesTaxRate: number;
  salesTaxAmount: number;
  totalAmount: number;
  note: string;
  rateId?: number;
  allowAutomaticUpdate: boolean;
}

export interface UpdateTrackingEventCommand {
  trackingEventId: number;
  values: UpdateTrackingEventCommandValues;
}

export interface CreateTrackingEventCommand {
  values: CreateTrackingEventCommandValues;
}

export interface GetTrackingEventsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
}

export interface TrackingEventDto {
  trackingEventId: number;
  description: string;
  location: string;
  eventDate: Date | string;
  eventDefinitionId: number;
  eventDefinition?: EventDefinitionDto;
  eventName?: string;
  isInactive: boolean;
  includeInTracking: boolean;
  sendEmail: boolean;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface TrackingEventDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: TrackingEventDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateTrackingEventCommandValues {
  description: string;
  location: string;
  eventDate: Date | string;
  eventDefinitionId: number;
  isInactive: boolean;
  includeInTracking: boolean;
  sendEmail: boolean;
}

export interface UpdateTrackingEventCommandValues {
  description: string;
  location: string;
  eventDate: Date | string;
  eventDefinitionId: number;
  isInactive: boolean;
  includeInTracking: boolean;
  sendEmail: boolean;
}

export interface EventDefinitionDto {
  eventDefinitionId: number;
  isAutomaticCreate: boolean;
  trigger: EventTrigger | undefined;
  description: string;
  location: string;
  eventName: string;
  isInactive: boolean;
  includeInTracking: boolean;
  sendEmail: boolean;
  organizationId: number;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
  createdByUserName?: string | undefined;
  lastModifiedByUserName?: string | undefined;
  sendEmailDocumentId?: number;
  customValues?: object | undefined;
}

export interface EventDefinitionDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: EventDefinitionDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateEventDefinitionCommandValues {
  isAutomaticCreate: boolean;
  trigger: EventTrigger | undefined;
  description: string;
  location: string;
  eventName: string;
  isInactive: boolean;
  includeInTracking: boolean;
  sendEmail: boolean;
  sendEmailDocumentId?: number;
  customValues?: object | undefined;
}

export interface UpdateEventDefinitionCommandValues {
  isAutomaticCreate: boolean;
  trigger: EventTrigger | undefined;
  description: string;
  location: string;
  eventName: string;
  isInactive: boolean;
  includeInTracking: boolean;
  sendEmail: boolean;
  sendEmailDocumentId?: number;
  customValues?: object | undefined;
}

export enum AutomaticCreate {
  Manual = 'Manual',
  OrderHasBeenSetAsPending = 'Order Has Been Set As Pending',
  OrderHasBeenCreated = 'Order Has Been Created',
  OrderHasBeenSetAsOpen = 'Order Has Been Set As Open',
  OrderHasBeenSetAsRefused = 'Order Has Been Set As Refused',
  OrderHasBeenSetAsCovered = 'Order Has Been Set As Covered',
  OrderHasBeenSetAsDispatched = 'Order Has Been Set As Dispatched',
  OrderHasBeenSetAsOnRoute = 'Order Has Been Set As On Route',
  OrderHasBeenSetAsLoading = 'Order Has Been Set As Loading',
  OrderHasBeenSetAsUnloading = 'Order Has Been Set As Unloading',
  OrderHasBeenSetAsInYard = 'Order Has Been Set As In Yard',
  OrderHasBeenSetAsInvoiced = 'Order Has Been Set As Invoiced',
  OrderHasBeenSetAsDelivered = 'Order Has Been Set As Delivered',
  OrderHasBeenSetAsCompleted = 'Order Has Been Set As Completed',
  OrderHasBeenSetAsCancelled = 'Order Has Been Set As Cancelled',
  OrderHasBeenEmailed = 'Order Has Been Emailed',
}

export interface EventTrigger {
  entity: string;
  conditionFields: { [key: string]: string };
  eventName: string;
}

export enum OrderEvents {
  SetAsPending = 'Set As Pending',
  Created = 'Created',
  SetAsOpen = 'Set As Open',
  SetAsRefused = 'Set As Refused',
  SetAsCovered = 'Set As Covered',
  SetAsDispatched = 'Set As Dispatched',
  SetAsOnRoute = 'Set As On Route',
  SetAsLoading = 'Set As Loading',
  SetAsUnloading = 'Set As Unloading',
  SetAsInYard = 'Set As In Yard',
  SetAsInvoiced = 'Set As Invoiced',
  SetAsDelivered = 'Set As Delivered',
  SetAsCompleted = 'Set As Completed',
  SetAsCancelled = 'Set As Cancelled',
  Emailed = 'Emailed',
}

export interface PortDto {
  portId?: number | string | undefined;
  isAir?: boolean;
  isBorderCrossingPoint?: boolean;
  countryCode?: string | undefined;
  countryCodeName?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  isMyCompany?: boolean;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  isMail?: boolean;
  isMariTime?: boolean;
  name?: string | undefined;
  organizationId?: number;
  portRemarks?: string | undefined;
  isRail?: boolean;
  isRoad?: boolean;
  stateCode?: string | undefined;
  stateName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface PortDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: PortDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface StateDto {
  organizationId?: number;
  countryCode?: string | undefined;
  stateCode?: string | undefined;
  name?: string | undefined;
  links?: LinkDto[] | undefined;
  countryName?: string | undefined;
  customValues?: object | undefined;
}

export interface StateDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: StateDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface UpdateContactAddressCommandValues {
  addressLine?: string | undefined;
  addressLine2?: string | undefined;
  addressType?: AddressType;
  cityName?: string | undefined;
  contactId?: number;
  countryCode?: string | undefined;
  postalCode?: string | undefined;
  stateCode?: string | undefined;
  customValues?: object | undefined;
}

export interface UpdateContactCommandValues {
  accountNumber?: string | undefined;
  contactFirstName?: string | undefined;
  contactLastName?: string | undefined;
  contactType?: ContactType;
  divisionId?: number;
  emailAddress?: string | undefined;
  faxNumber?: string | undefined;
  idNumber?: string | undefined;
  idNumberType?: IDNumberType;
  mobilePhoneNumber?: string | undefined;
  name?: string | undefined;
  linkToContactId?: number | undefined;
  phoneNumber?: string | undefined;
  website?: string | undefined;
  creditLimit?: number | undefined;
  paidAs?: PaidAs | undefined;
  isACorporation?: boolean | undefined;
  carrierEquipments?: CarrierEquipmentDto[] | undefined;
  customValues?: object | undefined;
}

export interface UpdateContainerDescriptionCommandValues {
  description?: string | undefined;
}

export interface UpdateContainerTypeCommandValues {
  description?: string | undefined;
}

export interface UpdateCountryCommandValues {
  name?: string | undefined;
}

export interface UpdateDivisionCommandValues {
  assignDivisionToEntities?: boolean;
  comments?: string | undefined;
  divisionName?: string | undefined;
  email?: string | undefined;
  faxNumber?: string | undefined;
  phoneNumber?: string | undefined;
  useDivisionInDocumentHeaders?: boolean;
  streetAndNumber?: string | undefined;
  city?: string | undefined;
  countryCode?: string | undefined;
  countryName?: string | undefined;
  zipCode?: string | undefined;
  stateCode?: string | undefined;
  stateName?: string | undefined;
  portId?: number | string | undefined;
  portName?: string | undefined;
  airAMSOriginatorCode?: string | undefined;
}

export interface UpdateEquipmentTypeCommandValues {
  name?: string | undefined;
}

export interface UpdateOrderCommandValues {
  billToContactId?: number | undefined;
  divisionId?: number;
  employeeContactId?: number | undefined;
  equipmentTypeId?: number | undefined;
  orderNumber?: string | undefined;
  orderStatusId?: number | undefined;
  orderType?: OrderTypes;
  salespersonContactId?: number | undefined;
  trackingNumber?: number;
  orderEntities?: UpdateOrderEntityCommand[] | undefined;
  commodities?: UpdateCommodityCommand[] | undefined;
  charges?: UpdateChargeCommand[] | undefined;
  trackingEvents?: CreateTrackingEventCommand[] | undefined;
  carriersId: number[];
  customValues?: object | undefined;
}

export interface UpdateCommodityCommand {
  commodityId: number;
  values: UpdateCommodityCommandValues;
}

export interface UpdateCommodityCommandValues {
  commodityStatusId?: number | undefined;
  description: string;
  dimensionsUnit: string;
  height: number;
  length: number;
  organizationId: number;
  packageTypeId: number;
  pieces: number;
  volumePiece: number;
  volumeTotal: number;
  volumeUnit: string;
  weightTotal: number;
  weight: number;
  weightByTotal: boolean;
  weightUnit: string;
  width: number;
  quantity: number;
  unit: number;
  unitaryValue: number;
  note: string;
  commodityTypeId?: number;
  customValues?: object;
  isRemoved?: boolean;
}

export interface UpdateOrganizationCommandValues {
  addressLine?: string | undefined;
  addressLine2?: string | undefined;
  cityName?: string | undefined;
  companyName?: string | undefined;
  countryCode?: string | undefined;
  faxNumber?: string | undefined;
  phoneNumber?: string | undefined;
  postalCode?: string | undefined;
  stateCode?: string | undefined;
}

export interface UpdatePackageCategoryCommandValues {
  isContainer?: boolean;
  name?: string | undefined;
}

export interface UpdatePackageTypeCommandValues {
  air?: boolean;
  containerDescriptionCode?: string | undefined;
  containerTypeCode?: string | undefined;
  ground?: boolean;
  height?: number;
  length?: number;
  maximumWeight?: number;
  name?: string | undefined;
  ocean?: boolean;
  packageCategoryCode?: string | undefined;
  volume?: number;
  weight?: number;
  width?: number;
}

export interface UpdatePortCommandValues {
  air?: boolean;
  borderCrossingPoint?: boolean;
  countryCode?: string | undefined;
  isMyCompany?: boolean;
  mail?: boolean;
  mariTime?: boolean;
  name?: string | undefined;
  portRemarks?: string | undefined;
  rall?: boolean;
  road?: boolean;
  stateCode?: string | undefined;
}

export interface UpdateStateCommandValues {
  name?: string | undefined;
}

export interface UpdateUserCommandValues {
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  newPassword?: string | undefined;
}

export interface SendDocumentCommandValues {
  subject?: string | undefined;
  emailBody?: string | undefined;
  recipients?: string[] | undefined;
  documentTemplateIds?: number[] | undefined;
  metadata?: any | undefined;
}

export interface UserDto {
  userId?: string | undefined;
  email?: string | undefined;
  avatarUrl?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  userName?: string | undefined;
  links?: LinkDto[] | undefined;
  isPassword?: boolean;
  isConfirmPassword?: boolean;
  confirmPassword?: any;
  organizationDivisionIds?: any;
  roles?: string[];
  divisionId?: number;
  isInOrgAdminRole?: boolean;
  isInOperationRole?: boolean;
  isInAccountingRole?: boolean;
  isInOrgUserRole?: boolean;
  isInSysAdminRole?: boolean;
  organizationVisibleTransactions?: any;
  visibleTransactions?: VisibleTransactions;
}

export enum RolesEnum {
  SysAdmin = 'SysAdmin',
  SysUser = 'SysUser',
  OrgAdmin = 'OrgAdmin',
  OrgUser = 'OrgUser',
  Operations = 'Operations',
  Accounting = 'Accounting',
  Customer = 'Customer',
  Receiving = 'Receiving',
  Anonymous = 'Anonymous',
  Administrator = 'Administrator',
  Agent = 'Agent',
}

export interface UserDtoForList extends UserDto {
  name?: string | undefined;
}

export interface CreateUserCommandValues {
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
}

export interface UserDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: UserDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface UserRegistrationDto {
  userId?: string | undefined;
  oneTimeAuthorizationCode?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface ValidationProblemDetails {
  errors?: { [key: string]: string[] } | undefined;
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
}

export interface GetCustomFieldsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface GetUserGroupsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
}

export interface CustomFieldDto {
  fieldId?: number | undefined;
  category?: string | undefined;
  customFieldEntityType?: string | undefined;
  customFieldType?: string | undefined;
  description?: string | undefined;
  displayName?: string | undefined;
  fieldConfig?: object | undefined;
  internalName?: string | undefined;
  isInactive?: boolean | undefined;
  isSystem?: boolean | undefined;
  organizationId?: number | undefined;
  created?: Date | string | undefined;
  createdBy?: string | undefined;
  lastModified?: Date | string | undefined;
  lastModifiedBy?: string | undefined;
  createdByUserName?: string | undefined;
  lastModifiedByUserName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface CustomFieldDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: CustomFieldDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateCustomFieldCommandValues {
  category?: string;
  customFieldEntityType?: string;
  customFieldType?: string;
  description?: string;
  displayName?: string;
  fieldConfig?: object;
  internalName?: string;
  isInactive?: boolean;
}

export interface UpdateCustomFieldCommandValues {
  category?: string;
  customFieldEntityType?: string;
  customFieldType?: string;
  description?: string;
  displayName?: string;
  fieldConfig?: object;
  isInactive?: boolean;
}

export interface UserEmployeeDto {
  userEmployeeId?: number;
  employeeContactId?: number;
  organizationId?: number;
  userId?: string;
  visibleTransactions?: VisibleTransactions;
  userUserName?: string;
  links?: LinkDto[];
  created?: Date | string;
  createdBy?: string;
  lastModified?: Date | string;
  lastModifiedBy?: string;
  userGroups?: UserGroupDto[];
}

export interface UserGroupDto {
  userGroupId?: number;
  created?: Date | string;
  createdBy?: string;
  description?: string;
  lastModified?: Date | string;
  lastModifiedBy?: string;
  name?: string;
  organizationId?: number;
  userRoles?: UserRoleDto[];
  links?: LinkDto[];
}

export interface UserGroupDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: UserGroupDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface UserRoleDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: UserRoleDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface UserRoleDto {
  id?: string;
  name?: string;
  normalizedName?: string;
}

export interface CreateUserGroupCommandValues {
  name?: string;
  description?: string;
  groupRules?: UserRoleDto[];
}

export interface UpdateUserGroupCommandValues {
  name?: string;
  description?: string;
}

export interface PaymentDto {
  organizationId?: number;
  paymentId?: number;
  accountingAccountId?: number;
  amountReceived?: number | string;
  amountPaid?: number;
  applyToContactId?: number;
  checkNumber?: string;
  currencyId?: number;
  currencyDecimals?: DecimalPlace;
  currencySymbol?: string;
  divisionId?: number;
  memo?: string;
  paymentDate?: Date | string;
  accountingAccountName?: string;
  accountingAccountType?: AccountType | undefined;
  applyToContactName?: string;
  createdByUserName?: string;
  updatedByUserName?: string;
  currencyName?: string;
  currency?: CurrencyDto;
  divisionName?: string;
  accountingTransactionPayments?: AccountingTransactionPaymentDto[];
  created?: Date | string;
  createdBy?: string;
  lastModified?: Date | string;
  lastModifiedBy?: string;
  paymentStatus?: PaymentStatus;
  links?: LinkDto[];
  customValues?: object | undefined;
}

export interface PaymentDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: PaymentDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreatePaymentCommandValues {
  accountingAccountId?: number;
  amountReceived?: number | string;
  applyToContactId?: number;
  checkNumber?: string;
  currencyId?: number;
  divisionId?: number;
  memo?: string;
  paymentDate?: Date | string;
  accountingTransactionPayments?: AccountingTransactionPaymentDto[];
}

export interface UpdatePaymentCommandValues {
  accountingAccountId?: number;
  amountReceived?: number | string;
  applyToContactId?: number;
  checkNumber?: string;
  currencyId?: number;
  divisionId?: number;
  memo?: string;
  paymentDate?: Date | string;
  accountingTransactionPayments?: AccountingTransactionPaymentDto[];
  paymentStatus?: PaymentStatus;
}

export interface AccountingTransactionPaymentDto {
  paymentId?: number;
  accountingTransactionId?: number;
  transactionNumber?: string;
  amountApplied?: number;
  amountDue?: number;
}

export interface CarrierEquipmentDto {
  carrierId?: number;
  equipmentTypeId?: number;
  quantity?: number;
}

export interface AttachmentDto {
  attachmentId: number;
  attachmentType: AttachmentType;
  created: Date;
  createdBy: string;
  description: string;
  fileName: string;
  fileUri: string;
  previewUri: string;
  thumbnailUri: string;
  presignedFileUri: string;
  presignedPreviewUri: string;
  presignedThumbnailUri: string;
  lastModified: Date;
  lastModifiedBy: string;
  organizationId: number;
  parentId: number;
  parentType: AttachmentParentType;
  createdByUserName: string;
  lastModifiedByUserName: string;
  prefix?: string;
  links: LinkDto[];
}

export interface AttachmentDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: AttachmentDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateAttachmentCommandValues {
  attachmentType?: AttachmentType;
  description?: string;
  fileName?: string;
  parentId?: number;
  parentType?: AttachmentParentType;
}

export interface UpdateAttachmentCommandValues {
  description?: string;
}

export type Column = {
  name: string;
  visible: boolean;
  title: string;
  type?:
    | 'string'
    | 'number'
    | 'bool'
    | 'date'
    | 'Date'
    | 'contact'
    | 'List'
    | 'orderStatus'
    | 'commodityStatus'
    | 'idNumberType'
    | 'customField'
    | 'rateType'
    | 'movementType'
    | 'movementStatus'
    | 'modeOfTransportation'
    | 'checkBox'
    | 'contactStatus'
    | 'activityLocation'
    | 'Country';
  customFieldType?: string;
  contactType?: ContactType;
  contactTypes?: ContactType[];
  showFilter?: boolean;
  dataField?: string;
  sortName?: string;
  filterFieldName?: string;
  labelToShow?: string;
  visibleForOrderTypes?: OrderTypes[] | null | undefined;
  orderTypes?: OrderTypes[] | null | undefined;
  selectable?: boolean;
  width?: string;
};

export interface TrackingDto {
  from?: string;
  to?: string;
  pieces?: number;
  weight?: number;
  volume?: number;
  weightUnit?: string;
  volumeUnit?: string;
  events?: TrackingEventDto[];
}

export enum QuoteStatuses {
  Posted = 'Posted',
}

export interface CommodityTypeDto {
  commodityTypeId: number;
  organizationId: number;
  code: string;
  description?: string;
  isActive?: boolean;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
  customValues?: object | undefined;
}

export interface CommodityTypeDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: CommodityTypeDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateCommodityTypeCommandValues {
  description?: string;
  code?: string;
  isActive?: boolean;
  customValues?: object | undefined;
}

export interface UpdateCommodityTypeCommandValues {
  description?: string;
  code?: string;
  isActive?: boolean;
  customValues?: object | undefined;
}

export enum LocationType {
  Receiving = 'Receiving',
  Storage = 'Storage',
  Replenishment = 'Replenishment',
  Picking = 'Picking',
  QualityControl = 'QualityControl',
  Shipping = 'Shipping',
  Mobile = 'Mobile',
  Other = 'Other',
  Packing = 'Packing',
  Service = 'Service',
  PutAway = 'PutAway',
}

export interface WarehouseLocationDto {
  warehouseLocationId: number;
  organizationId: number;
  code: string;
  customerId?: number;
  description?: string;
  customerName?: string;
  locationType: LocationType;
  height?: number;
  length?: number;
  width?: number;
  maximumWeight?: number;
  isInactive: boolean;
  parentZoneId?: number;
  parentWarehouseZoneName?: string;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
  commodities?: CommodityDto[];
}

export interface WarehouseZoneDto {
  warehouseZoneId: number;
  organizationId: number;
  name: string;
  description?: string;
  parentZoneId?: number;
  divisionId?: number;
  nestedZonesCount?: number;
  nestedLocationsCount?: number;
  divisionName?: string;
  customerId?: number;
  customerName?: string;
  isHasNestedZones?: boolean;
  parentWarehouseZoneName?: string;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
  commodities?: CommodityDto[];
}

export interface WarehouseLocationDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: WarehouseLocationDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateWarehouseLocationCommandValues {
  code: string;
  customerId?: number;
  description?: string;
  customerName?: string;
  locationType: LocationType;
  height?: number;
  length?: number;
  width?: number;
  maximumWeight?: number;
  isInactive: boolean;
  parentZoneId?: number;
}

export interface UpdateWarehouseLocationCommandValues {
  customerId?: number;
  description?: string;
  customerName?: string;
  locationType: LocationType;
  height?: number;
  length?: number;
  width?: number;
  maximumWeight?: number;
  isInactive: boolean;
  parentZoneId?: number;
}

export interface WarehouseZoneDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: WarehouseZoneDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateWarehouseZoneCommandValues {
  description?: string;
  name?: string;
  parentZoneId?: number;
  divisionId?: number;
  customerId?: number;
}

export interface UpdateWarehouseZoneCommandValues {
  description?: string;
  name?: string;
  parentZoneId?: number;
  divisionId?: number;
  customerId?: number;
}

export enum EntityTypes {
  Shipper = 'Shipper',
  Consignee = 'Consignee',
  Carrier = 'Carrier',
  Vendor = 'Vendor',
  UltimateConsignee = 'UltimateConsignee',
  NotifyParty = 'NotifyParty',
  Intermediate = 'Intermediate',
  ForwardingAgent = 'ForwardingAgent',
  DestinationAgent = 'DestinationAgent',
  PickupFrom = 'PickupFrom',
  DeliverTo = 'DeliverTo',
  DeliveryCarrier = 'DeliveryCarrier',
  ReceivedBy = 'ReceivedBy',
}

//purchases
export interface OrderEntityDto {
  orderEntityId: number;
  contactAddressId?: number | undefined;
  contactAddressName?: string | undefined;
  contactId?: number | undefined;
  contactName?: string | undefined;
  nonContactName?: string | undefined;
  contactType?: ContactType;
  created: Date;
  createdBy?: string | undefined;
  date?: Date;
  notes?: string | undefined;
  lastModified: Date;
  lastModifiedBy?: string | undefined;
  orderEntitySequence: number;
  orderId: number;
  contactCityName?: string | undefined;
  contactCountryName?: string | undefined;
  contactStateCode?: string | undefined;
  entityType?: EntityTypes;
  customValues?: object | undefined;
  links?: LinkDto[] | undefined;
}

export interface UpdateOrderEntityCommand {
  orderEntityId: number;
  values: UpdateOrderEntityCommandValues;
}

export interface CreateOrderEntityCommandValues {
  contactAddressId?: number | undefined;
  contactId?: number | undefined;
  nonContactName?: string | undefined;
  orderEntitySequence: number;
  entityType?: EntityTypes | undefined;
  customValues?: object | undefined;
}

export interface UpdateOrderEntityCommandValues {
  contactAddressId?: number | undefined;
  contactId?: number | undefined;
  nonContactName?: string | undefined;
  orderEntitySequence: number;
  entityType?: EntityTypes;
  customValues: object | undefined;
}

export interface ClauseDto {
  clauseId: number;
  organizationId: number;
  category: string;
  name: string;
  description: string;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface ClauseDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ClauseDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateClauseCommandValues {
  category: string;
  name: string;
  description: string;
}

export interface UpdateClauseCommandValues {
  category: string;
  name: string;
  description: string;
}

export interface CommodityCustomValues {
  purposeOfCommodity?: PurposeOfCommodityValues;
  dangerousItems?: string | DangerousItemsValues[];
  pallet?: number;
  packingStatus?: string;
  content_verified?: string;
  content_verified_by?: any;
  content_verified_on?: any;
}

export interface CountryCustomValues {
  isActive?: boolean;
}

//custom codes
export enum CustomCodeType {
  ScheduleD = 'ScheduleD',
  ScheduleK = 'ScheduleK',
}

export interface CustomCodeDto {
  code?: string | undefined;
  description?: string | undefined;
  organizationId?: number;
  isCommonlyUsed?: boolean | undefined;
  codeType: CustomCodeType;
  links?: LinkDto[] | undefined;
}

export interface CustomCodeDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: CustomCodeDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateCustomCodeCommandValues {
  code?: string | undefined;
  description?: string | undefined;
  isCommonlyUsed?: boolean | undefined;
  codeType: CustomCodeType;
}

export interface UpdateCustomCodeCommandValues {
  description?: string | undefined;
  isCommonlyUsed?: boolean | undefined;
  codeType: CustomCodeType;
}

export interface GetCustomCodesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

export interface VesselDto {
  vesselId: number;
  organizationId: number;
  name: string;
  vesselCode?: string;
  carrierId?: number;
  carrierName?: string;
  countryCode?: string;
  countryName?: string;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface VesselDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: VesselDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateVesselCommandValues {
  name: string;
  vesselCode?: string;
  carrierId?: number;
  countryCode?: string;
}

export interface UpdateVesselCommandValues {
  name: string;
  vesselCode?: string;
  carrierId?: number;
  countryCode?: string;
}

export enum RatePerType {
  Unit = 'Unit',
  Range = 'Range',
}

export interface TariffDto {
  baseCharge?: number;
  maximum?: number;
  minimum?: number;
  applyBy?: ApplyBy;
  unitType?: WeightUnit | VolumeUnit;
  ratePerType?: RatePerType;
  ratePer?: number;
  rates?: number[][];
  rateData?: RateDataDto[];
  calculatedOf?: CalculatedOf;
  rateMultiplier?: number;
}

export interface RateDataDto {
  rateIndex?: any;
  rateValue: number;
}

export enum CalculatedOf {
  Income = 'Income',
  IncomeFreight = 'Income (Freight Only)',
  Expense = 'Expense',
  Profit = 'Profit',
}

export enum PaymentType {
  Card = 'Card',
}

export interface ContactPaymentMethodDto {
  contactPaymentMethodId: number;
  contactId: number;
  customerId: string;
  description?: string;
  expDate: string;
  paymentType: PaymentType;
  customValues?: object | undefined;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface RateDto {
  rateId?: number;
  organizationId?: number;
  accountingItemId?: number | undefined;
  amendmendNumber?: string | undefined;
  applyToDestinationCountry?: boolean | undefined;
  applyToOriginCountry?: boolean | undefined;
  automaticallyCreateCharge?: boolean;
  carrierId?: number | undefined;
  finalMileCarrierId?: number | undefined;
  clientId?: number | undefined;
  commodityTypeId?: number | undefined;
  contractNumber?: string | undefined;
  countryOfDestinationCode?: string | undefined;
  countryOfOriginCode?: string | undefined;
  currencyId?: number | undefined;
  effectiveDate?: Date | undefined;
  expirationDate?: Date | undefined;
  frequency?: Frequency;
  isHazardous?: boolean | undefined;
  modeOfTransportationId?: number | undefined;
  notes?: string | undefined;
  portOfDeliveryId?: string | undefined;
  portOfLoadingId?: string | undefined;
  portOfReceiptId?: string | undefined;
  portOfUnloadingId?: string | undefined;
  rateType?: RateType;
  serviceType?: ServiceType;
  tariff?: TariffOptions;
  transitDaysMin?: number | undefined;
  transitDaysMax?: number | undefined;
  portOfReceipt?: PortDto;
  portOfLoading?: PortDto;
  portOfUnloading?: PortDto;
  portOfDelivery?: PortDto;
  countryOfOrigin?: CountryDto;
  countryOfDestination?: CountryDto;
  currency?: CurrencyDto;
  accountingItem?: AccountingItemDto;
  modeOfTransportation?: ModeOfTransportationDto;
  client?: ContactDto;
  finalMileCarrier?: ContactDto;
  carrier?: ContactDto;
  commodityType?: CommodityTypeDto;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  createdByUserName?: string | undefined;
  lastModifiedByUserName?: string | undefined;
  customValues?: { [key: string]: string } | undefined;
  links?: LinkDto[] | undefined;
}

export interface ContactPaymentMethodDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ContactPaymentMethodDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface ContactPaymentMethodViewDto {
  contactPaymentMethodId: number;
  contactId: number;
  customerId: string;
  description?: string;
  expDate: string;
  paymentType: PaymentType;
  customValues?: object | undefined;
  links?: LinkDto[] | undefined;
}

export enum RateType {
  StandardClientRate = 'StandardClientRate',
  ClientRate = 'ClientRate',
  CarrierRate = 'CarrierRate',
}

export enum Frequency {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Biweekly = 'Biweekly',
  Monthly = 'Monthly',
  Other = 'Other',
}

export interface TariffOptions {
  maximum?: number | undefined;
  minimum?: number | undefined;
  rateMultiplier?: number | undefined;
  applyBy?: ApplyBy;
  unitType?: Units;
  ratePerType?: RatePerType;
  ratePer?: number | undefined;
  rates?: number[][] | undefined;
  calculatedOf?: CalculatedOf;
  rateData?: RateDataDto[];
}

export enum Units {
  Lb = 'Lb',
  Vlb = 'Vlb',
  Vkg = 'Vkg',
  M = 'M',
}

export interface RateDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: RateDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateRateCommandValues {
  accountingItemId?: number | undefined;
  amendmendNumber?: string | undefined;
  applyToDestinationCountry?: boolean;
  applyToOriginCountry?: boolean;
  automaticallyCreateCharge?: boolean;
  finalMileCarrierId?: number | undefined;
  carrierId?: number | undefined;
  clientId?: number | undefined;
  commodityTypeId?: number | undefined;
  contractNumber?: string | undefined;
  countryOfDestinationCode?: string | undefined;
  countryOfOriginCode?: string | undefined;
  currencyId?: number | undefined;
  effectiveDate?: Date | undefined;
  expirationDate?: Date | undefined;
  frequency?: Frequency;
  isHazardous?: boolean | undefined;
  modeOfTransportationId?: number | undefined;
  notes?: string | undefined;
  portOfDeliveryId?: string | undefined;
  portOfLoadingId?: string | undefined;
  portOfReceiptId?: string | undefined;
  portOfUnloadingId?: string | undefined;
  rateType?: RateType;
  serviceType?: ServiceType;
  tariff?: TariffOptions;
  transitDaysMin?: number | undefined;
  transitDaysMax?: number | undefined;
  customValues?: object | undefined;
}

export interface UpdateRateCommandValues {
  accountingItemId?: number | undefined;
  amendmendNumber?: string | undefined;
  applyToDestinationCountry?: boolean | undefined;
  applyToOriginCountry?: boolean | undefined;
  automaticallyCreateCharge?: boolean;
  finalMileCarrierId?: number | undefined;
  carrierId?: number | undefined;
  clientId?: number | undefined;
  commodityTypeId?: number | undefined;
  contractNumber?: string | undefined;
  countryOfDestinationCode?: string | undefined;
  countryOfOriginCode?: string | undefined;
  currencyId?: number | undefined;
  effectiveDate?: Date | undefined;
  expirationDate?: Date | undefined;
  frequency?: Frequency;
  isHazardous?: boolean | undefined;
  modeOfTransportationId?: number | undefined;
  notes?: string | undefined;
  portOfDeliveryId?: string | undefined;
  portOfLoadingId?: string | undefined;
  portOfReceiptId?: string | undefined;
  portOfUnloadingId?: string | undefined;
  rateType?: RateType;
  serviceType?: ServiceType;
  tariff?: TariffOptions;
  transitDaysMin?: number | undefined;
  transitDaysMax?: number | undefined;
  customValues?: object | undefined;
}

export interface GetRatesQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
}

//ShipmentQuote
export interface QuoteChargeDto {
  type?: ChargeType;
  amount?: number | undefined;
}

export interface QuoteAccountingItemDto {
  accountingItemId?: number;
  quantity?: number;
}

export interface ShipmentQuoteDto {
  charges?: QuoteChargeDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface QuoteCommodityDto {
  weight?: number;
}

export interface GetShipmentQuoteQueryValues {
  rateId?: number;
  commodities?: QuoteCommodityDto[] | undefined;
  accountingItems?: QuoteAccountingItemDto[] | undefined;
}

export interface GetAccountingItemsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  view?: string | undefined;
  summary?: boolean;
}

export interface OrderDocumentDto {
  orderDocumentId?: number;
  orderDocumentName?: string;
  documentTemplateId?: number;
  lastGeneratedFile?: string | undefined;
  lastGeneratedTime?: Date | undefined;
  orderId?: number;
  regenerateOnOrderChange?: boolean;
  created?: Date;
  createdByUserName?: string | undefined;
  lastModified?: Date;
  lastModifiedByUserName?: string | undefined;
  links?: LinkDto[] | undefined;
  documentTemplate?: DocumentTemplateDto;
  workflowId?: string | undefined;
}

export interface CreateOrderDocumentCommandValues {
  documentTemplateId?: number;
  regenerateOnOrderChange?: boolean;
}

export interface OrderDocumentDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: OrderDocumentDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface UpdateOrderDocumentCommandValues {
  documentTemplateId?: number;
  lastGeneratedFile?: string | undefined;
  lastGeneratedTime?: Date | undefined;
  regenerateOnOrderChange?: boolean;
}

export interface GetEventDefinitionsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  summary?: boolean;
  include?: string | undefined;
  fields?: string | undefined;
}

export interface CreateOrderDocumentsCommandValues {
  documentTemplateId?: number;
  regenerateOnOrderChange?: boolean;
  metadata?: { [key: string]: string } | undefined;
}

export interface RegenerateOrderDocumentCommandValues {
  documentTemplateId: number;
  metadata?: { [key: string]: string } | undefined;
}

export interface WarehouseLocationDtoWizardPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: WarehouseLocationWizardDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface WarehouseLocationWizardDto {
  warehouseLocationId: number;
  organizationId: number;
  code: string;
  customerId?: number;
  description?: string;
  customerName?: string;
  locationType: LocationType;
  height?: number;
  length?: number;
  width?: number;
  maximumWeight?: number;
  isInactive: boolean;
  parentZoneId?: number;
  parentWarehouseZoneName?: string;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
  commodities?: CommodityDto[] | undefined;
}

export interface BusinessRuleAction {
  action?: string | undefined;
}

export interface BusinessRuleCondition {
  triggerEvent?: TriggerEvents;
  condition?: string | undefined;
  trigger?: Trigger;
}

export enum Trigger {
  Before = 'Before',
  After = 'After',
}

export enum TriggerEvents {
  OrderCreated = 'OrderCreated',
  OrderUpdated = 'OrderUpdated',
  OrderStatusChanged = 'OrderStatusChanged',
  AccountingTransactionCreated = 'AccountingTransactionCreated',
  AccountingTransactionUpdated = 'AccountingTransactionUpdated',
  CommodityContainerChanged = 'CommodityContainerChanged',
  AccountingTransactionStatusChanged = 'AccountingTransactionStatusChanged',
  ActionEventCreated = 'ActionEventCreated',
  CommodityStatusChanged = 'CommodityStatusChanged',
}

export interface BusinessRuleDto {
  businessRuleId?: number;
  actions?: BusinessRuleAction[] | undefined;
  conditions?: BusinessRuleCondition[] | undefined;
  description?: string | undefined;
  isEnabled?: boolean;
  isSynchronized?: boolean;
  isSystem?: boolean;
  name?: string | undefined;
  organizationId?: number;
  priority?: number;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  createdByUserName?: string | undefined;
  lastModifiedByUserName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface BusinessRuleDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: BusinessRuleDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateBusinessRuleCommandValues {
  actions?: BusinessRuleAction[] | undefined;
  conditions?: BusinessRuleCondition[] | undefined;
  description?: string | undefined;
  isEnabled?: boolean;
  name?: string | undefined;
  priority?: number;
}

export interface UpdateBusinessRuleCommandValues {
  actions?: BusinessRuleAction[] | undefined;
  conditions?: BusinessRuleCondition[] | undefined;
  description?: string | undefined;
  isEnabled?: boolean;
  name?: string | undefined;
  priority?: number;
}

export enum StatusStage {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Inactive = 'Inactive',
}

export interface OrderStatusDto {
  orderStatusId?: number;
  organizationId?: number;
  orderStatusDescription?: string | undefined;
  orderStatusName?: string | undefined;
  orderType?: OrderTypes;
  priority?: number;
  statusStage?: StatusStage;
  requireConfirmation: boolean;
  customValues?: object | undefined;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface OrderStatusDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: OrderStatusDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateOrderStatusCommandValues {
  orderStatusDescription?: string | undefined;
  orderStatusName?: string | undefined;
  orderType?: OrderTypes;
  priority?: number;
  statusStage?: StatusStage;
}

export interface UpdateOrderStatusCommandValues {
  orderStatusDescription?: string | undefined;
  orderStatusName?: string | undefined;
  orderType?: OrderTypes;
  priority?: number;
  statusStage?: StatusStage;
}

export enum ContactStatusStage {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum FileType {
  Default = 'Default',
  Csv = 'Csv',
  Xlsx = 'Xlsx',
  Json = 'Json',
  Pdf = 'Pdf',
  Png = 'Png',
}

export interface ContactStatusDto {
  statusId?: number;
  contactType?: ContactType;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number;
  priority?: number;
  statusDescription?: string | undefined;
  statusName?: string | undefined;
  statusStage?: ContactStatusStage;
  createdUserFirstName?: string | undefined;
  createdUserLastName?: string | undefined;
  createdUserNormalizedUserName?: string | undefined;
  createdUserUserName?: string | undefined;
  updatedUserFirstName?: string | undefined;
  updatedUserLastName?: string | undefined;
  updatedUserNormalizedUserName?: string | undefined;
  updatedUserUserName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface ContactStatusDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: ContactStatusDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateContactStatusCommandValues {
  contactType?: ContactType;
  priority?: number;
  statusDescription?: string | undefined;
  statusName?: string | undefined;
  statusStage?: ContactStatusStage;
}

export interface UpdateContactStatusCommandValues {
  contactType?: ContactType;
  priority?: number;
  statusDescription?: string | undefined;
  statusName?: string | undefined;
  statusStage?: ContactStatusStage;
}

export interface CreateCommodityTrackingNumberCommandValues {
  commodityId: number;
  trackingNumber: string;
  syncOrderId?: number;
  isPrimary: boolean;
}

export interface DeleteCommodityTrackingNumberCommandValues {
  commodityId: number;
  trackingNumber: string;
  commodityTrackingNumberId: number;
  isPrimary: boolean;
}

export interface UpdateCommodityTrackingNumberCommandValues {
  commodityId: number;
  trackingNumber: string;
  syncOrderId?: number;
  isPrimary: boolean;
}

export interface CommodityTrackingNumberDto {
  commodityTrackingNumberId: number;
  commodityId: number;
  trackingNumber: string;
  syncOrderId?: number;
  isPrimary: boolean;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface CommodityTrackingNumberDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: CommodityTrackingNumberDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface OrganizationConfigDto {
  organizationConfigId?: number;
  organizationId: number;
  configName: string;
  customValues?: object | string | undefined;
  links?: LinkDto[] | undefined;
}

export interface OrganizationConfigDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: OrganizationConfigDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateOrganizationConfigCommandValues {
  organizationId: number;
  configName: string;
  customValues?: object | string | undefined;
}

export interface UpdateOrganizationConfigCommandValues {
  configName: string;
  customValues?: object | string | undefined;
}

export enum PickingActivityStatuses {
  Picked = 'Picked',
  AwaitingPicking = 'Awaiting Picking',
  Damaged = 'Damaged',
  NotFound = 'Not Found',
}

export enum PackingStatuses {
  Scanned = 'Scanned',
  NotScanned = 'Not Scanned',
  Packed = 'Packed',
}

export enum PutAwayActivityStatuses {
  Completed = 'Completed',
  InMovement = 'In Movement',
}

export interface OrderContextValues {
  billToContactId?: number;
  packageDescription?: number;
  employeeContactId?: number;
}

export interface OrderCommodityDto {
  commodityId?: number;
  orderId?: number;
  created?: Date;
  createdBy?: string | undefined;
  customValues?: { [key: string]: any } | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  commodity?: CommodityDto;
  links?: LinkDto[] | undefined;
}

export interface OrderCommodityDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: OrderCommodityDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateOrderCommodityCommandValues {
  commodityId?: number;
  customValues?: { [key: string]: any } | undefined;
}

export interface UpdateOrderCommodityCommandValues {
  customValues?: { [key: string]: any } | undefined;
}

export interface CommodityStatusDto {
  statusId?: number;
  created?: Date;
  createdBy?: string | undefined;
  description?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number;
  priority?: number;
  statusName: string;
  statusStage?: CommodityStatusStage;
  createdUserFirstName?: string | undefined;
  createdUserLastName?: string | undefined;
  createdUserNormalizedUserName?: string | undefined;
  createdUserUserName?: string | undefined;
  updatedUserFirstName?: string | undefined;
  updatedUserLastName?: string | undefined;
  updatedUserNormalizedUserName?: string | undefined;
  updatedUserUserName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export enum CommodityStatusStage {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Completed = 'Completed',
}

export interface CommodityStatusDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: CommodityStatusDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateCommodityStatusCommandValues {
  description?: string | undefined;
  priority?: number;
  statusName: string;
  statusStage?: CommodityStatusStage;
}

export interface UpdateCommodityStatusCommandValues {
  description?: string | undefined;
  priority?: number;
  statusName: string;
  statusStage?: CommodityStatusStage;
}

export interface CityDto {
  organizationId?: number;
  cityId?: number;
  cityName?: string | undefined;
  countryCode?: string | undefined;
  countryName?: string | undefined;
  stateCode?: string | undefined;
  stateName?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  customValues?: object | undefined;
  links?: LinkDto[] | undefined;
}

export interface CityDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: CityDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateCityCommandValues {
  cityId?: number | undefined;
  cityName?: string | undefined;
  countryCode?: string | undefined;
  stateCode?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  customValues?: object | undefined;
}

export interface UpdateCityCommandValues {
  cityName?: string | undefined;
  countryCode?: string | undefined;
  stateCode?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  customValues?: object | undefined;
}

export interface UserSettingDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: UserSettingDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface UserSettingDto {
  userSettingId?: number;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  name?: string | undefined;
  organizationId?: number;
  settings?: { [key: string]: any } | undefined;
  userId?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateUserSettingCommandValues {
  name?: string | undefined;
  settings?: { [key: string]: any } | undefined;
  userId?: string | undefined;
}

export interface UpdateUserSettingCommandValues {
  name?: string | undefined;
  settings?: { [key: string]: any } | undefined;
  userId?: string | undefined;
}

export interface UpdateDefaultViewCommandValues {
  viewName?: string;
  defaultValue?: boolean;
  userSettingId?: number | null;
}

export enum ScanningResultFrom {
  Scanner = 'scanner',
  Input = 'input',
}

export interface ActionEventDto {
  eventId?: string;
  created?: Date;
  createdBy?: string | undefined;
  errorMessage?: string | undefined;
  eventData?: { [key: string]: any } | undefined;
  eventName?: string | undefined;
  organizationId?: number;
  status?: EventStatus;
  links?: LinkDto[] | undefined;
}

export interface ActionEventDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: ActionEventDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface GetActionEventsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  summary?: boolean;
}

export interface CreateActionEventCommandValues {
  errorMessage?: string | undefined;
  eventData?: { [key: string]: any } | undefined;
  eventName?: string | undefined;
  status?: EventStatus;
}

export interface UpdateActionEventCommandValues {
  errorMessage?: string | undefined;
  eventData?: { [key: string]: any } | undefined;
  eventName?: string | undefined;
  status?: EventStatus;
}

export enum EventStatus {
  Pending = 'Pending',
  Completed = 'Completed',
  Failed = 'Failed',
}

export enum S3UriTypes {
  FileUri = 'FileUri',
  PreviewUri = 'PreviewUri',
  ThumbnailUri = 'ThumbnailUri',
}

export enum DiscountType {
  Percentage = 'Percentage',
  FixedAmount = 'FixedAmount',
}

export interface DiscountDto {
  discountId?: number;
  activationCount?: number;
  activationLimit?: number | undefined;
  created?: Date;
  createdBy?: string | undefined;
  customValues?: { [key: string]: any } | undefined;
  description?: string | undefined;
  endDate?: Date;
  isActive?: boolean;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  minimumChargeAmount?: number | undefined;
  name?: string | undefined;
  organizationId?: number;
  promoCode?: string | undefined;
  startDate?: Date;
  targetContactTags?: string[] | undefined;
  type?: DiscountType;
  usageLimit?: number | undefined;
  usedCount?: number;
  value?: number;
  carriers?: ContactDto[] | undefined;
  transportationModes?: ModeOfTransportationDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface DiscountDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: DiscountDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateDiscountCommandValues {
  activationCount?: number;
  activationLimit?: number | undefined;
  customValues?: { [key: string]: any } | undefined;
  description?: string | undefined;
  endDate?: Date;
  isActive?: boolean;
  minimumChargeAmount?: number | undefined;
  name?: string | undefined;
  promoCode?: string | undefined;
  startDate?: Date;
  targetContactTags?: string[] | undefined;
  type?: DiscountType;
  usageLimit?: number | undefined;
  usedCount?: number;
  value?: number;
  carriers?: ContactDto[] | undefined;
  transportationModes?: ModeOfTransportationDto[] | undefined;
}

export interface UpdateDiscountCommandValues {
  activationCount?: number;
  activationLimit?: number | undefined;
  customValues?: { [key: string]: any } | undefined;
  description?: string | undefined;
  endDate?: Date;
  isActive?: boolean;
  minimumChargeAmount?: number | undefined;
  name?: string | undefined;
  promoCode?: string | undefined;
  startDate?: Date;
  targetContactTags?: string[] | undefined;
  type?: DiscountType;
  usageLimit?: number | undefined;
  usedCount?: number;
  value?: number;
  carriers?: ContactDto[] | undefined;
  transportationModes?: ModeOfTransportationDto[] | undefined;
}

export interface GetDiscountsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  summary?: boolean;
}

export interface WorkflowDto {
  workflowId?: string;
  created?: Date;
  createdBy?: string | undefined;
  isActive?: boolean;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number;
  workflowYamlDocument?: string | undefined;
  createdUserFirstName?: string | undefined;
  createdUserLastName?: string | undefined;
  createdUserNormalizedUserName?: string | undefined;
  createdUserUserName?: string | undefined;
  updatedUserFirstName?: string | undefined;
  updatedUserLastName?: string | undefined;
  updatedUserNormalizedUserName?: string | undefined;
  updatedUserUserName?: string | undefined;
  workflowName?: string | undefined;
  workflowDescription?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface WorkflowDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: WorkflowDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateWorkflowCommandValues {
  isActive?: boolean;
  workflowYamlDocument?: string | undefined;
}

export interface UpdateWorkflowCommandValues {
  isActive?: boolean;
  workflowDocument?: { [key: string]: any } | undefined;
  workflowYamlDocument?: string | undefined;
}

export interface WorkflowExecutionResult {
  outputs?: { [key: string]: any } | undefined;
}

export interface WorkflowInputDto {
  name?: string | undefined;
  type?: string | undefined;
  props?: WorkflowInputProps | undefined;
}

export interface WorkflowInputProps {
  additionalProperties?: { [key: string]: any } | undefined;
  required?: boolean;
  defaultValue?: any | undefined;
  multiple?: boolean;
  displayName?: string | undefined;
  description?: string | undefined;
}

export interface WorkflowTriggerDto {
  workflowId?: string;
  organizationId?: number;
  workflowName?: string | undefined;
  workflowDescription?: string | undefined;
  workflowType?: string | undefined;
  inputs?: WorkflowInputDto[] | undefined;
  isAsync?: boolean;
  readonly isActive?: boolean;
  links?: LinkDto[] | undefined;
  props?: WorkflowTriggerProps | undefined;
}

export interface WorkflowTriggerProps {
  additionalProperties?: { [key: string]: any } | undefined;
}

export interface WorkflowTriggerDtoListResult {
  items?: WorkflowTriggerDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface GetWorkflowTriggersQuery {
  triggerType?: string | undefined;
  organizationId?: number;
  entityName?: string | undefined;
  eventType?: string | undefined;
}

export interface WorkflowTriggerListItemDto {
  workflowId?: string;
  organizationId?: number;
  workflowName?: string | undefined;
  workflowDescription?: string | undefined;
  isAsync?: boolean;
  isActive?: boolean;
  links?: LinkDto[] | undefined;
}

export interface WorkflowTriggerListItemDtoListResult {
  items?: WorkflowTriggerListItemDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface ExecuteWorkflowCommandValues {
  workflowId?: string;
  variables?: { [key: string]: any } | undefined;
}

export interface JobDto {
  jobId?: string;
  created?: Date;
  createdBy?: string | undefined;
  customValues?: { [key: string]: string } | undefined;
  customerId?: number | undefined;
  description?: string | undefined;
  divisionId?: number | undefined;
  employeeId?: number;
  jobNumber?: string | undefined;
  jobStatusId?: number | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number;
  createdUserUserName?: string | undefined;
  customerName?: string | undefined;
  divisionDivisionName?: string | undefined;
  employeeName?: string | undefined;
  updatedUserUserName?: string | undefined;
  jobStatusJobStatusName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface JobListItemDto {
  jobId?: string;
  created?: Date;
  createdBy?: string | undefined;
  customValues?: { [key: string]: string } | undefined;
  customerId?: number | undefined;
  description?: string | undefined;
  divisionId?: number | undefined;
  employeeId?: number;
  jobNumber?: string | undefined;
  jobStatusId?: number | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number;
  createdUserUserName?: string | undefined;
  customerName?: string | undefined;
  divisionDivisionName?: string | undefined;
  employeeName?: string | undefined;
  jobStatusJobStatusName?: string | undefined;
  updatedUserUserName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface JobListItemDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: JobListItemDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface JobStatusDto {
  jobStatusId?: number;
  created?: Date;
  createdBy?: string | undefined;
  customValues?: { [key: string]: string } | undefined;
  jobStatusName?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number;
  priority?: number;
  statusStage?: StatusStage;
  createdUserFirstName?: string | undefined;
  createdUserLastName?: string | undefined;
  createdUserNormalizedUserName?: string | undefined;
  createdUserUserName?: string | undefined;
  updatedUserFirstName?: string | undefined;
  updatedUserLastName?: string | undefined;
  updatedUserNormalizedUserName?: string | undefined;
  updatedUserUserName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface JobStatusListItemDto {
  jobStatusId?: number;
  created?: Date;
  createdBy?: string | undefined;
  customValues?: { [key: string]: string } | undefined;
  jobStatusName?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number;
  priority?: number;
  statusStage?: StatusStage;
  createdUserUserName?: string | undefined;
  updatedUserUserName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface JobStatusListItemDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: JobStatusListItemDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface CreateJobCommandValues {
  customValues?: { [key: string]: string } | undefined;
  customerId?: number | undefined;
  description?: string | undefined;
  divisionId?: number | undefined;
  employeeId?: number;
  jobNumber?: string | undefined;
  jobStatusId?: number | undefined;
}

export interface CreateJobStatusCommandValues {
  customValues?: { [key: string]: string } | undefined;
  jobStatusName?: string | undefined;
  priority?: number;
  statusStage?: StatusStage;
}

export interface UpdateJobStatusCommandValues {
  customValues?: { [key: string]: string } | undefined;
  jobStatusName?: string | undefined;
  priority?: number;
  statusStage?: StatusStage;
}

export interface UpdateJobCommandValues {
  customValues?: { [key: string]: string } | undefined;
  customerId?: number | undefined;
  description?: string | undefined;
  divisionId?: number | undefined;
  employeeId?: number;
  jobNumber?: string | undefined;
  jobStatusId?: number | undefined;
}

export interface GetJobsQuery {
  organizationId?: number;
  limit?: number;
  offset?: number;
  sort?: string | undefined;
  filter?: string | undefined;
  search?: string | undefined;
  summary?: boolean;
  include?: string | undefined;
  fields?: string | undefined;
}

export interface CreateAppModuleCommandValues {
  appManifestId?: string | undefined;
  appModuleYamlDocument?: string | undefined;
}

export interface AppModuleDto {
  appModuleId?: string;
  appManifestId?: string | undefined;
  appModuleYamlDocument?: string | undefined;
  appModuleDocument?: { [key: string]: any } | undefined;
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  name?: string | undefined;
  organizationId?: number;
  appManifestName?: string | undefined;
  links?: LinkDto[] | undefined;
}

export interface AppModuleListItemDtoPagedResult {
  offset?: number;
  limit?: number;
  totalCount?: number;
  summary?: { [key: string]: any } | undefined;
  items?: AppModuleDto[] | undefined;
  links?: LinkDto[] | undefined;
}

export interface UpdateAppModuleCommandValues {
  appManifestId?: string | undefined;
  appModuleYamlDocument?: string | undefined;
}
